import styled from "styled-components/macro";

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin-right: 1rem;
  padding: 0.1rem;
  gap: 1.5rem;
`;

export const Column = styled.div`
  grid-column: span ${({ $span }) => $span || 1} / span ${({ $span }) => $span || 1};
`;
